module.exports = __webpack_public_path__ + "img/detail5-1.5a8f0990.png";